
import {useSupportPWA} from "@shared/hooks/useSupportPWA";
import {Button} from "@shared/ui/Button";


export const AboutGame = () => {

    const {supportsPWA, installPWA} = useSupportPWA()

    return (
        <div>
            {supportsPWA &&
                <Button onClick={(e) => installPWA(e)}>Install</Button>
            }
            <div>
                dasfdfddddddddddddd
            </div>

        </div>
    )
}